import { Link } from 'react-router-dom';
import { Wordmark } from '../../components/Wordmark';

export function ApplicationSubmittedPage() {
  return (
    <div className="min-h-screen flex flex-col bg-bg">
      {/* Header */}
      <header className="border-b border-line chrome-gradient">
        <div className="page-container h-14 flex items-center gap-5">
          <Wordmark />
        </div>
      </header>

      {/* Content */}
      <div className="page-container flex-1 flex items-center justify-center">
        <div className="max-w-md text-center">
          <div className="form-eyebrow mb-4">Application received</div>
          <h1 className="form-heading mb-4">Thank you for applying</h1>
          <p className="text-text-dim text-[15px] leading-relaxed mb-8">
            We review applications regularly and will be in touch soon.
          </p>
          <Link
            to="/"
            className="btn btn-primary"
          >
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
